t = require('app/scripts/views/internal/teacup-with-helpers')('board_desc')

module.exports = ->
  t.div '.window-header.u-clearfix', ->

    t.span '.window-header-icon.icon-lg.icon-board'

    t.div { class: 'window-title non-empty u-inline ' + t.mustacheBlock('__own', (-> ' editable ')) + ' ', attr: 'name' }, ->
      t.h2 '.window-title-text.current.hide-on-edit', ->
        t.text t.mustacheVar('name')
      t.mustacheBlock '__own', ->
        t.p '.edits-warning.quiet', ->
          t.format 'you-have-unsaved-edits-on-this-field'
          t.text ' '
          t.a '.js-view-edits', { href: '#' }, ->
            t.format 'view-edits'
          t.text " - "
          t.a '.js-discard-edits', { href: '#' }, ->
            t.format 'discard'
        t.div '.edit.edit-heavy', ->
          t.textarea '.field.single-line', { type: 'text' }

  t.div '.window-main-col.window-main-col-full', ->

    t.div { class: 'board-description u-clearfix' + t.mustacheBlock('__ed', (-> ' editable')), attr: 'desc' }, ->
      t.div '.current.markeddown.hide-on-edit.u-bottom', ->
        t.mustacheBlockInverted 'hasDesc', ->
          t.p '.u-bottom', ->
            t.mustacheBlock '__ed', ->
              t.a '.quiet.empty', { style: 'padding: 100px 0;', href: '#' }, ->
                t.format 'no-description-click-to-edit'
            t.mustacheBlockInverted '__ed', ->
              t.span '.quiet.empty', { style: 'padding: 100px 0;' }, ->
                t.format 'no-description'
      t.mustacheBlock '__ed', ->
        t.mustacheBlock 'hasDesc', ->
          t.p '.u-bottom.js-edit-desc', ->
            t.a '.quiet-button.mod-with-image.hide-on-edit', { href: '#' }, ->
              t.icon 'edit', 'edit-the-board-description', { class: 'quiet-button-icon' }
        t.p '.edits-warning.quiet', ->
          t.format 'you-have-unsaved-edits-on-this-field'
          t.text ' '
          t.a '.js-view-edits', { href: '#' }, ->
            t.format 'view-edits'
          t.text " - "
          t.a '.js-discard-edits', { href: '#' }, ->
            t.format 'discard'
        t.div '.board-description-edit.edit', ->
          t.p '.helper', ->
            t.format 'markdown-accepted'
          t.textarea '.field'

